// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__bZGjM","container":"styles_container__36D39","title":"styles_title__1QeL8","wrapper":"styles_wrapper__2D4DG","answer":"styles_answer__3om0C"};